


































































































































































































































































































































































































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import {
  meterCosts,
  deleteMeterCost,
  DeleteMeterCostReq,
  UpdateMeterCostReq,
  AddMeterCostReq,
  addMeterCost,
  updateMeterCost,
  QueryHolidayDateReq,
  queryHolidaysDates,
  holidaysDates,
  GetMeterCostReq,
  GetHolidayReq,
  GetNextMeterCostReq,
  nextMeterCost,
} from "@/api/meterCost";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  MeterCost,
  RuleCost,
  HolidayDate,
  Company,
  MeterType,
} from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { DeepCopy } from "../../utils/ObjectCopy";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import { meterTypes, MeterTypeReq } from "@/api/meter";
import { formatDate } from "../../utils/dateUtil";
import { MeterUtil } from "@/utils/meterUtil";

/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
  },
})
export default class CostSet extends Vue {
  private selectLevel = 0;
  private selectMeterCost: MeterCost = <MeterCost>{};
  private getMeterCostReq: GetMeterCostReq = <GetMeterCostReq>{};
  private isSearch: boolean = false;
  private queryHolidays: HolidayDate[] = [];
  private selectRuleCostIndex = 0;
  private ruleTypeNames: string[] = [];
  private ruless: RuleCost[][] = [];
  private dialogAddOrUpdate = false;
  private dialogDelete = false;
  private dialogAddOrUpdateRule = false;
  private list: MeterCost[] = [];
  private listLoading: boolean = true;
  private loading: boolean = false;
  private dialogType = "edit"; //判断弹出层是添加还是编辑
  private dialogRuleType = "edit"; //判断弹出层是添加还是编辑
  private total = 0;
  private usageDisabled = false;
  private meterCost: MeterCost = <MeterCost>{};
  private selectRuleCost: RuleCost = <RuleCost>{};
  private showHoliday = false;
  private ruleCost: RuleCost = <RuleCost>{};
  private rules: string[] = [];
  private rule: string = "";
  private clickNextDelete: boolean = false;

  private listQuery: GetMeterCostReq = <GetMeterCostReq>{
    page: 1,
    pageSize: 10,
  };
  private pickerOptions = {
    start: "00:00",
    step: "00:30",
    end: "24:00",
  };

  private queryCompanys: Company[] = [];
  private moneyUnits: string[] = [];
  public onSelectCompany(b) {
    if (b) {
      this.queryCompany("");
    }
  }
  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }

  public onHolidaychange() {
    for (let item of this.queryHolidays) {
      if (item.name === this.meterCost.holidayName) {
        this.meterCost.holidayID = item.id;
        return;
      }
    }
  }
  public onSelectHoliday(b) {
    if (b) {
      this.queryHolidayReqest("");
    }
  }

  public search() {
    this.isSearch = true;
    this.listQuery.page = 1;
    this.getList();
  }

  public resetSearch() {
    this.getMeterCostReq = <GetMeterCostReq>{};
  }
  private meterTypes: MeterType[] = [];

  public async getList() {
    this.listLoading = true;
    let req: GetMeterCostReq = <GetMeterCostReq>{};
    if (this.isSearch) {
      req = this.getMeterCostReq;
      req.page = this.listQuery.page;
      req.pageSize = this.listQuery.pageSize;
    } else {
      req = this.listQuery;
    }
    const res = await meterCosts(req);
    if (res.code === ResCode.SUCCESS) {
      this.list = res.data.meterCostData.list;
      this.total = res.data.meterCostData.totalCount;
    }
    this.listLoading = false;
  }
  public changeUsageType() {
    this.reset();
    this.meterCost.usageType = this.rules.indexOf(this.rule);
    this.showHoliday = this.meterCost.usageType === 0;
    this.changeRuleTypeNames();
  }

  public async clickAddBtn(scope) {
    let meterCost = <MeterCost>DeepCopy(scope.row);
    const res = await nextMeterCost(<GetNextMeterCostReq>{
      meterCostID: meterCost.id,
    });

    if (res && res.code === ResCode.SUCCESS) {
      this.selectLevel = 1;
      this.selectMeterCost = meterCost;
      if (!!res.data && !!res.data.meterCost) {
        this.meterCost = res.data.meterCost;
        this.updateNextMeterCost("edit");
      } else {
        this.reset();
        this.addNewNextMeterCost();
      }
    }
  }
  public clickUpdateBtn(scope) {
    this.selectLevel = 0;
    this.meterCost = <MeterCost>DeepCopy(scope.row);
    this.showHoliday = this.meterCost.usageType === 0;
    this.updateNextMeterCost("view");
  }

  public updateNextMeterCost(dialogType: string) {
    this.dialogType = dialogType;
    this.dialogAddOrUpdate = true;
    this.usageDisabled = true;
    this.ruless = [
      this.meterCost.normalRuleS,
      this.meterCost.saturdayRuleS,
      this.meterCost.sundayRuleS,
      this.meterCost.holidayRuleS,
    ];
    this.rule = this.rules[this.meterCost.usageType];
    this.changeRuleTypeNames();
  }
  public addNewNextMeterCost() {
    this.dialogType = "new";
    this.dialogAddOrUpdate = true;
    this.usageDisabled = false;
    this.rule = this.rules[0];
    this.meterCost.usageType = this.rules.indexOf(this.rule);
    this.changeRuleTypeNames();
    this.showHoliday = this.meterCost.usageType === 0;
  }

  public changeRuleTypeNames() {
    if (this.meterCost.usageType > 0) {
      this.ruleTypeNames = [this.$t("costSet.normal").toString()];
    } else {
      this.ruleTypeNames = [
        this.$t("costSet.normal").toString(),
        this.$t("costSet.saturday").toString(),
        this.$t("costSet.sunday").toString(),
        this.$t("costSet.holiday").toString(),
      ];
    }
  }

  public reset() {
    this.meterCost = <MeterCost>{};
    this.meterCost.normalRuleS = [];
    this.meterCost.saturdayRuleS = [];
    this.meterCost.sundayRuleS = [];
    this.meterCost.holidayRuleS = [];
    this.ruless = [
      this.meterCost.normalRuleS,
      this.meterCost.saturdayRuleS,
      this.meterCost.sundayRuleS,
      this.meterCost.holidayRuleS,
    ];
  }
  public clickDeleteBtn(scope) {
    this.dialogDelete = true;
    this.clickNextDelete = false;
    this.meterCost = <MeterCost>DeepCopy(scope.row);
  }

  public clickCancel() {
    if (this.dialogType === "edit") {
      this.clickNextDelete = true;
      this.dialogDelete = true;
    } else {
      this.dialogAddOrUpdate = false;
    }
  }

  public clickAddRuleBtn(index: number) {
    this.dialogRuleType = "new";
    this.dialogAddOrUpdateRule = true;
    this.ruleCost = <RuleCost>{};
    this.selectRuleCostIndex = index;
  }

  public clickUpdateRuleBtn(type: number, index: number) {
    this.dialogRuleType = "edit";
    this.dialogAddOrUpdateRule = true;

    if (type === 0) {
      this.selectRuleCost = this.meterCost.normalRuleS[index];
      this.ruleCost = Object.assign({}, this.meterCost.normalRuleS[index]);
    } else if (type === 1) {
      this.selectRuleCost = this.meterCost.saturdayRuleS[index];
      this.ruleCost = Object.assign({}, this.meterCost.saturdayRuleS[index]);
    } else if (type === 2) {
      this.selectRuleCost = this.meterCost.sundayRuleS[index];
      this.ruleCost = Object.assign({}, this.meterCost.sundayRuleS[index]);
    } else if (type === 3) {
      this.selectRuleCost = this.meterCost.holidayRuleS[index];
      this.ruleCost = Object.assign({}, this.meterCost.holidayRuleS[index]);
    }
    this.rules = [
      this.$t("costSet.timeRule").toString(),
      this.$t("costSet.usageRule").toString(),
    ];
    this.rule = this.rules[this.ruleCost.usageType];
  }

  public clickDeleteRuleBtn(type: number, index: number) {
    if (type === 0) {
      this.meterCost.normalRuleS.splice(index, 1);
    } else if (type === 1) {
      this.meterCost.saturdayRuleS.splice(index, 1);
    } else if (type === 2) {
      this.meterCost.sundayRuleS.splice(index, 1);
    } else if (type === 3) {
      this.meterCost.holidayRuleS.splice(index, 1);
    }
  }

  public addOrUpdateMeterCost() {
    if (this.dialogType === "new") {
      this.createMeterCost();
    } else {
      this.updateMeterCost();
    }
  }

  public async createMeterCost() {
    if (!this.IsMeterCostLegal()) {
      alert(this.$t("notification.inputIllegal").toString());
      return;
    }
    let req = this.meterCost;
    if (this.selectLevel === 1) {
      req = <MeterCost>{ id: this.selectMeterCost.id };
      req.nextMeterCost = this.meterCost;
      req.nextMeterCost.meterTypeID = this.selectMeterCost.meterTypeID;
      if (!!req.nextMeterCost.updateDate) {
        let date = new Date(req.nextMeterCost.updateDate);
        let paymentDate = UserModule.companyPaymentDate;
        if (date.getDate() !== paymentDate || date.getTime() < Date.now()) {
          this.$notify({
            title: this.$t("common.warning").toString(),
            message: this.$t("notification.MeterCostDateError").toString(),
            type: "warning",
          });
          return;
        }
        req.nextMeterCost.updateDate = formatDate(date);
      }
    }
    const res = await addMeterCost(<AddMeterCostReq>{
      meterCost: req,
    });
    if (res && res.code === ResCode.SUCCESS) {
      this.dialogAddOrUpdate = false;
      this.getList();
    }
  }

  public async updateMeterCost() {
    if (!this.IsMeterCostLegal()) {
      alert(this.$t("notification.inputIllegal").toString());
      return;
    }
    if (!!this.meterCost.updateDate) {
      let date = new Date(this.meterCost.updateDate);
      if (
        date.getDate() !== UserModule.companyPaymentDate ||
        date.getTime() < Date.now()
      ) {
        this.$notify({
          title: this.$t("common.warning").toString(),
          message: this.$t("notification.MeterCostDateError").toString(),
          type: "warning",
        });
        return;
      }
      this.meterCost.updateDate = formatDate(new Date(date));
    }
    const res = await updateMeterCost(<UpdateMeterCostReq>{
      meterCost: this.meterCost,
    });

    if (res && res.code === ResCode.SUCCESS) {
      this.dialogAddOrUpdate = false;
      this.getList();
    }
  }

  public async deleteMeterCost() {
    const res = await deleteMeterCost(<DeleteMeterCostReq>{
      meterCostID: this.clickNextDelete
        ? this.selectMeterCost.id
        : this.meterCost.id,
      nextMeterCostFlag: this.clickNextDelete,
    });
    if (res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.DeleteMeterCostSuccess").toString(),
        type: "success",
      });
      if (this.clickNextDelete) {
        this.dialogAddOrUpdate = false;
      }
      this.dialogDelete = false;
      this.getList();
    }
  }

  public addOrUpdateRuleCost() {
    if (this.dialogRuleType === "new") {
      this.createRuleCost();
    } else {
      this.updateRuleCost();
    }
  }

  public async updateRuleCost() {
    if (!this.checkRuleCost()) {
      alert(this.$t("notification.pleaseInputAll").toString());
      return;
    }
    this.dialogAddOrUpdateRule = false;
    this.ruleCost.usageType = this.rules.indexOf(this.rule);
    if (!!this.ruleCost.cost) {
      this.selectRuleCost.cost = this.ruleCost.cost;
    }
    if (!!this.ruleCost.startTime) {
      this.selectRuleCost.startTime = this.ruleCost.startTime;
    }
    if (!!this.ruleCost.endTime) {
      this.selectRuleCost.endTime = this.ruleCost.endTime;
    }

    if (!!this.ruleCost.startUsage) {
      this.selectRuleCost.startUsage = this.ruleCost.startUsage;
    }
    if (!!this.ruleCost.endUsage) {
      this.selectRuleCost.endUsage = this.ruleCost.endUsage;
    }
  }

  public async queryHolidayReqest(query: string) {
    let res = await holidaysDates({
      page: 1,
      pageSize: 10,
      name: query,
    } as GetHolidayReq);
    if (res.code === ResCode.SUCCESS) {
      this.queryHolidays = res.data.holidayDateData.list;
    }
  }

  private async created() {
    let meterArray = this.$t("meterTypeArray");
    let meterTypeResponse = await meterTypes(<MeterTypeReq>{});
    for (let i = 0; i < meterTypeResponse.data.meterTypes.list.length; i++) {
      let meterType: MeterType = <MeterType>{
        id: meterTypeResponse.data.meterTypes.list[i].id,
        name: meterArray[meterTypeResponse.data.meterTypes.list[i].id - 1],
      };
      this.meterTypes.push(meterType);
    }
    this.rules = [
      this.$t("costSet.timeRule").toString(),
      this.$t("costSet.usageRule").toString(),
    ];
    this.moneyUnits = [
      this.$t("moneyUnit.CNY").toString(),
      this.$t("moneyUnit.JPY").toString(),
      this.$t("moneyUnit.USD").toString(),
    ];

    this.getList();
  }

  public async createRuleCost() {
    if (!this.checkRuleCost()) {
      alert(this.$t("notification.inputIllegal").toString());
      return;
    }
    this.ruleCost.usageType = this.rules.indexOf(this.rule);
    if (this.selectRuleCostIndex === 0) {
      this.dialogAddOrUpdateRule = false;
      this.meterCost.normalRuleS.push(this.ruleCost);
      this.sortRuleCost(this.meterCost.normalRuleS);
    } else if (this.selectRuleCostIndex === 1) {
      this.dialogAddOrUpdateRule = false;
      this.meterCost.saturdayRuleS.push(this.ruleCost);
      this.sortRuleCost(this.meterCost.saturdayRuleS);
    } else if (this.selectRuleCostIndex === 2) {
      this.dialogAddOrUpdateRule = false;
      this.meterCost.sundayRuleS.push(this.ruleCost);
      this.sortRuleCost(this.meterCost.sundayRuleS);
    } else if (this.selectRuleCostIndex === 3) {
      this.dialogAddOrUpdateRule = false;
      this.meterCost.holidayRuleS.push(this.ruleCost);
      this.sortRuleCost(this.meterCost.holidayRuleS);
    }
  }

  private IsMeterCostLegal(): boolean {
    if (
      this.meterCost.usageType === 1 &&
      this.IsRuleCostLegal(this.meterCost.normalRuleS, false)
    ) {
      return true;
    }
    if (
      this.meterCost.usageType === 0 &&
      this.IsRuleCostLegal(this.meterCost.normalRuleS, true) &&
      this.IsRuleCostLegal(this.meterCost.saturdayRuleS, true) &&
      this.IsRuleCostLegal(this.meterCost.sundayRuleS, true) &&
      this.IsRuleCostLegal(this.meterCost.holidayRuleS, true)
    ) {
      return true;
    }
    return false;
  }

  private IsRuleCostLegal(ruleCosts: RuleCost[], allowEmpty: boolean): boolean {
    if (!ruleCosts || ruleCosts.length === 0) {
      return allowEmpty;
    }
    let typeSet = new Set();
    this.sortRuleCost(ruleCosts);
    if (this.rules.indexOf(this.rule) === 0) {
      for (let i = 0; i < ruleCosts.length; i++) {
        typeSet.add(ruleCosts[i].usageType);
        if (ruleCosts[i].startTime === ruleCosts[i].endTime) {
          return false;
        }
        if (i === 0 && ruleCosts[i].startTime !== "00:00") {
          return false;
        }
        if (i > 0 && ruleCosts[i - 1].endTime != ruleCosts[i].startTime) {
          return false;
        }
      }
    } else {
      for (let i = 0; i < ruleCosts.length; i++) {
        typeSet.add(ruleCosts[i].usageType);
        let startUsage = ruleCosts[i].startUsage;
        let endUsage = ruleCosts[i].endUsage;
        if (startUsage >= endUsage) {
          return false;
        }
        if (i === 0 && startUsage != 0) {
          return false;
        }
        if (i > 0 && ruleCosts[i - 1].endUsage != ruleCosts[i].startUsage) {
          return false;
        }
      }
    }
    if (typeSet.size > 1) {
      return false;
    }
    return true;
  }

  private sortRuleCost(ruleCosts: RuleCost[]) {
    if (this.rules.indexOf(this.rule) === 0) {
      ruleCosts.sort(function (a: RuleCost, b: RuleCost) {
        let as: string[] = a.startTime.split(":");
        let bs: string[] = b.startTime.split(":");
        if (
          Number(as[0]) * 60 + Number(as[1]) >
          Number(bs[0]) * 60 + Number(bs[1])
        ) {
          return 1;
        } else {
          return -1;
        }
      });
    } else {
      ruleCosts.sort(function (a: RuleCost, b: RuleCost) {
        if (a.startUsage > b.startUsage) {
          return 1;
        } else {
          return -1;
        }
      });
    }
  }
  private checkRuleCost(): boolean {
    if (!this.ruleCost.cost || isNaN(this.ruleCost.cost)) {
      return false;
    }
    if (this.rules.indexOf(this.rule) === 0) {
      if (!this.ruleCost.startTime || !this.ruleCost.endTime) {
        return false;
      }
      if (this.ruleCost.startTime === this.ruleCost.endTime) {
        return false;
      }
    } else {
      if (!this.ruleCost.endUsage) {
        this.ruleCost.endUsage = 9999999;
      }
      if (!this.ruleCost.startUsage || !this.ruleCost.endUsage) {
        return false;
      }
      if (isNaN(this.ruleCost.startUsage) || isNaN(this.ruleCost.endUsage)) {
        return false;
      }
      if (this.ruleCost.startUsage === this.ruleCost.endUsage) {
        return false;
      }
    }
    return true;
  }

  public dataRules = {
    startUsage: [
      { required: true, trigger: "blur", validator: this.validateNumber },
    ],
    endUsage: [
      { required: true, trigger: "blur", validator: this.validateNumber },
    ],
    cost: [{ required: true, trigger: "blur", validator: this.validateNumber }],
  };

  private validateNumber(rule: any, value: string, callback: any) {
    if (isNaN(Number(value))) {
      callback(new Error(this.$t("validate.onlyNumberPermission").toString()));
    } else {
      callback();
    }
  }
}
